export default "__VITE_ASSET__D_fjd2R___"